import { render, staticRenderFns } from "./RegiaoDetalhes.vue?vue&type=template&id=6e497809"
import script from "./RegiaoDetalhes.vue?vue&type=script&lang=js"
export * from "./RegiaoDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports